// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Manrope:wght@200;300;400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-text {
    text-align: left;
    font: normal normal normal 16px/22px Open Sans;
    letter-spacing: 0.8px;
    color: #494F54;
}

.status-text span {
    text-align: left;
    font: normal normal bold 16px/22px Open Sans;
    letter-spacing: 0.8px;
    color: #494F54;
}

.cat-section .container {
    max-width: 1550px;
}

.cat-section .title-bar {
    background: #EEEEEE 0% 0% no-repeat padding-box;
    opacity: 0.54;
    padding: 20px 0;
}

.cat-section .cardlist-title {
    text-align: left;
    font: normal normal 600 50px/68px Manrope;
    letter-spacing: 5px;
    color: #494F54;
    text-transform: capitalize;
    opacity: 1;
}

.cat-section .body-text {
    text-align: left;
    font: normal normal normal 16px/22px Open Sans;
    letter-spacing: 0.8px;
    color: #494F54;
    opacity: 1;
}

.cat-section .title-bar .title {
    text-align: left;
    font: normal normal 200 60px/82px Manrope;
    letter-spacing: 6px;
    color: #494F54;
    text-transform: lowercase;
    opacity: 1;
    margin-bottom: 0;
}

.unit-card .card-header {
    background: #DAF1F9 0% 0% no-repeat padding-box;
    border-radius: 0px 33px 0px 0px;
    opacity: 1;
    padding: 20px 0;
}

.unit-card .content-title {
    text-align: left;
    font: normal normal bold 22px/30px Open Sans;
    letter-spacing: 1.1px;
    color: #494F54;
    opacity: 1;
}

.unit-card{
    margin-bottom: 20px
}

.unit-card.card {
    border: none;
}

.unit-card .card-body {
    display: flex;
    gap: 10px;
    border: 1px solid #3463EF;
    border-top: 0;
    opacity: 1;
    padding: 20px 0;
}

.unit-card .content-subtitle {
    text-align: left;
    font: normal normal normal 16px/22px Open Sans;
    letter-spacing: 0.8px;
    color: #494F54;
    opacity: 1;
}

.unit-card .content-text {
    text-align: left;
    font: normal normal normal 16px/22px Open Sans;
    letter-spacing: 0.8px;
    color: #494F54;
    opacity: 1;
}

.unit-card .btn-secondary .carret {
    transition: all 0.3s ease;
}

.unit-card .btn-secondary p {
    text-align: left;
    font: normal normal 600 18px/24px Open Sans;
    letter-spacing: 2.7px;
    color: #FEF8E6;
    text-transform: lowercase;
    opacity: 1;
    margin-bottom: 0;
}

.unit-card .btn-secondary {
    background: #494F54 0% 0% no-repeat padding-box;
    opacity: 1;
    transition: all 0.3s ease;
    padding: 15px 15px;
}

.unit-card .btn-secondary .carret {
    display: inline-block;
    transition: all 0.3s ease;
}


.unit-card .btn-secondary:hover {
    background: #EEEEEE 0% 0% no-repeat padding-box;
    opacity: 1;
    transition: all 0.3s ease;
}

.unit-card .btn-secondary:hover .carret {
    transition: all 0.3s ease;
    opacity: 0;
}


.unit-card .btn-secondary:hover p {
    text-align: left;
    font: normal normal normal 18px/24px Open Sans;
    letter-spacing: 2.7px;
    color: #494F54;
    text-transform: lowercase;
    opacity: 1;
}


.unit-card .btn-link .carret {
    transition: all 0.3s ease;
}


.unit-card .btn-link p {
    text-align: left;
    font: normal normal 600 16px/22px Open Sans;
    letter-spacing: 2.4px;
    color: #247A3D;
    opacity: 1;
    margin-bottom: 0;
}

.unit-card .btn-link {
    transition: all 0.3s ease;
    position: relative;
    color: inherit;
    text-decoration: none;
}

.unit-card .btn-link::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background: transparent;
    transition: background 0.3s ease;
}

.unit-card .btn-link:hover::after {
    background: #247A3D;
    /* Green color for the line */
}

.unit-card .btn-link:hover p {
    text-align: left;
    font: normal normal bold 16px/22px Open Sans;
    letter-spacing: 2.4px;
    color: #247A3D;

}

.unit-card .btn-link:hover .carret {
    transition: all 0.3s ease;
    opacity: 0;
}

@media(max-width:767.5px){
    .cat-section .title-bar .title {
        text-align: left;
        font: normal normal 200 40px/62px Manrope;
    }
}`, "",{"version":3,"sources":["webpack://./src/screens/CATPage/cat.css"],"names":[],"mappings":"AAEA;IACI,gBAAgB;IAChB,8CAA8C;IAC9C,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,4CAA4C;IAC5C,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,+CAA+C;IAC/C,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,mBAAmB;IACnB,cAAc;IACd,0BAA0B;IAC1B,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,8CAA8C;IAC9C,qBAAqB;IACrB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,+CAA+C;IAC/C,+BAA+B;IAC/B,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,4CAA4C;IAC5C,qBAAqB;IACrB,cAAc;IACd,UAAU;AACd;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,yBAAyB;IACzB,aAAa;IACb,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,8CAA8C;IAC9C,qBAAqB;IACrB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,8CAA8C;IAC9C,qBAAqB;IACrB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,2CAA2C;IAC3C,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,+CAA+C;IAC/C,UAAU;IACV,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;;AAGA;IACI,+CAA+C;IAC/C,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,UAAU;AACd;;;AAGA;IACI,gBAAgB;IAChB,8CAA8C;IAC9C,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,UAAU;AACd;;;AAGA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,gBAAgB;IAChB,2CAA2C;IAC3C,qBAAqB;IACrB,cAAc;IACd,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,4CAA4C;IAC5C,qBAAqB;IACrB,cAAc;;AAElB;;AAEA;IACI,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI;QACI,gBAAgB;QAChB,yCAAyC;IAC7C;AACJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@200;300;400;500;600;700;800&display=swap');\n\n.status-text {\n    text-align: left;\n    font: normal normal normal 16px/22px Open Sans;\n    letter-spacing: 0.8px;\n    color: #494F54;\n}\n\n.status-text span {\n    text-align: left;\n    font: normal normal bold 16px/22px Open Sans;\n    letter-spacing: 0.8px;\n    color: #494F54;\n}\n\n.cat-section .container {\n    max-width: 1550px;\n}\n\n.cat-section .title-bar {\n    background: #EEEEEE 0% 0% no-repeat padding-box;\n    opacity: 0.54;\n    padding: 20px 0;\n}\n\n.cat-section .cardlist-title {\n    text-align: left;\n    font: normal normal 600 50px/68px Manrope;\n    letter-spacing: 5px;\n    color: #494F54;\n    text-transform: capitalize;\n    opacity: 1;\n}\n\n.cat-section .body-text {\n    text-align: left;\n    font: normal normal normal 16px/22px Open Sans;\n    letter-spacing: 0.8px;\n    color: #494F54;\n    opacity: 1;\n}\n\n.cat-section .title-bar .title {\n    text-align: left;\n    font: normal normal 200 60px/82px Manrope;\n    letter-spacing: 6px;\n    color: #494F54;\n    text-transform: lowercase;\n    opacity: 1;\n    margin-bottom: 0;\n}\n\n.unit-card .card-header {\n    background: #DAF1F9 0% 0% no-repeat padding-box;\n    border-radius: 0px 33px 0px 0px;\n    opacity: 1;\n    padding: 20px 0;\n}\n\n.unit-card .content-title {\n    text-align: left;\n    font: normal normal bold 22px/30px Open Sans;\n    letter-spacing: 1.1px;\n    color: #494F54;\n    opacity: 1;\n}\n\n.unit-card{\n    margin-bottom: 20px\n}\n\n.unit-card.card {\n    border: none;\n}\n\n.unit-card .card-body {\n    display: flex;\n    gap: 10px;\n    border: 1px solid #3463EF;\n    border-top: 0;\n    opacity: 1;\n    padding: 20px 0;\n}\n\n.unit-card .content-subtitle {\n    text-align: left;\n    font: normal normal normal 16px/22px Open Sans;\n    letter-spacing: 0.8px;\n    color: #494F54;\n    opacity: 1;\n}\n\n.unit-card .content-text {\n    text-align: left;\n    font: normal normal normal 16px/22px Open Sans;\n    letter-spacing: 0.8px;\n    color: #494F54;\n    opacity: 1;\n}\n\n.unit-card .btn-secondary .carret {\n    transition: all 0.3s ease;\n}\n\n.unit-card .btn-secondary p {\n    text-align: left;\n    font: normal normal 600 18px/24px Open Sans;\n    letter-spacing: 2.7px;\n    color: #FEF8E6;\n    text-transform: lowercase;\n    opacity: 1;\n    margin-bottom: 0;\n}\n\n.unit-card .btn-secondary {\n    background: #494F54 0% 0% no-repeat padding-box;\n    opacity: 1;\n    transition: all 0.3s ease;\n    padding: 15px 15px;\n}\n\n.unit-card .btn-secondary .carret {\n    display: inline-block;\n    transition: all 0.3s ease;\n}\n\n\n.unit-card .btn-secondary:hover {\n    background: #EEEEEE 0% 0% no-repeat padding-box;\n    opacity: 1;\n    transition: all 0.3s ease;\n}\n\n.unit-card .btn-secondary:hover .carret {\n    transition: all 0.3s ease;\n    opacity: 0;\n}\n\n\n.unit-card .btn-secondary:hover p {\n    text-align: left;\n    font: normal normal normal 18px/24px Open Sans;\n    letter-spacing: 2.7px;\n    color: #494F54;\n    text-transform: lowercase;\n    opacity: 1;\n}\n\n\n.unit-card .btn-link .carret {\n    transition: all 0.3s ease;\n}\n\n\n.unit-card .btn-link p {\n    text-align: left;\n    font: normal normal 600 16px/22px Open Sans;\n    letter-spacing: 2.4px;\n    color: #247A3D;\n    opacity: 1;\n    margin-bottom: 0;\n}\n\n.unit-card .btn-link {\n    transition: all 0.3s ease;\n    position: relative;\n    color: inherit;\n    text-decoration: none;\n}\n\n.unit-card .btn-link::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    height: 2px;\n    background: transparent;\n    transition: background 0.3s ease;\n}\n\n.unit-card .btn-link:hover::after {\n    background: #247A3D;\n    /* Green color for the line */\n}\n\n.unit-card .btn-link:hover p {\n    text-align: left;\n    font: normal normal bold 16px/22px Open Sans;\n    letter-spacing: 2.4px;\n    color: #247A3D;\n\n}\n\n.unit-card .btn-link:hover .carret {\n    transition: all 0.3s ease;\n    opacity: 0;\n}\n\n@media(max-width:767.5px){\n    .cat-section .title-bar .title {\n        text-align: left;\n        font: normal normal 200 40px/62px Manrope;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
